import { Link } from "react-router-dom";

export default function BrandHeader({ minimal = false }) {
  return (
    <header
      className="w-full border-b border-[var(--tt-border)] bg-[var(--tt-surface)]/80 backdrop-blur-sm sticky top-0 z-30"
      data-testid="brand-header"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <img
            src="/brand/logo.svg"
            alt="Travel Trucks"
            className="h-9 sm:h-10 w-auto"
          />
          <span className="hidden sm:block text-xs uppercase tracking-[0.2em] text-[var(--tt-muted)] font-medium">
            Staff Onboarding
          </span>
        </Link>
        {!minimal && (
          <Link
            to="/admin"
            className="text-xs uppercase tracking-[0.18em] text-[var(--tt-muted)] hover:text-[var(--tt-primary)] transition-colors"
            data-testid="admin-link"
          >
            Admin
          </Link>
        )}
      </div>
    </header>
  );
}
